<template>
  <i
    class="tm-optional-audio-insert-menu"
    :class="{
      // not v-if - cause of fade animation
      v: isRelevant,
    }"
    :style="styleObj"
  >
    <i class="-label">Insert audio</i>
    <i class="-buttons">
      <wt-button
        class="-long"
        type="primary"
        text="Keep full duration"
        @mouseup.native.left.stop="$_onClick_Push"
      />
      <wt-button
        class="-medium"
        type="hollow-dark"
        text="Trim to fit"
        @mouseup.native.left.stop="$_onClick_Trim"
      />
      <i class="-spring" />
      <wt-button
        class="-custom -short"
        type="hollow-dark"
        icon="wticon-trash-line"
        @mouseup.native.left.stop="$_onClick_Delete"
      />
    </i>
  </i>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import tmBus from 'v/Story/Timeline/api/tmBus';

export default {
  name: 'tm-optional-audio-insert-menu',

  computed: {
    ...mapState('timemachine', {
      MODE_OPTIONAL_AUDIO_INSERT: (state) => state.MODE.OPTIONAL_AUDIO_INSERT,
      axis: (state) => state.viewOffsets.axis,
      pxAxisSidePadding: (state) => state.cssVariables.pxAxisSidePadding,
      pxAudioDropMenuW: (state) => state.cssVariables.pxAudioDropMenuW,
      track: (state) => state.dndEscort.trackInHand,
    }),

    isRelevant() {
      return this.MODE_OPTIONAL_AUDIO_INSERT;
    },

    trackRectangle() {
      return this.isRelevant ? this.track?.rectangles[0] : null;
    },

    styleObj() {
      if (this.isRelevant && this.trackRectangle) {
        const point = this.trackRectangle.p1.clone();
        const rightEdge = this.axis.width - this.pxAxisSidePadding;
        const menuRightX = point.x + this.pxAudioDropMenuW;

        if (menuRightX > rightEdge) {
          const shiftLeft = menuRightX - rightEdge;
          point.shift(-shiftLeft, 0);
        }

        return {
          transform: `translate3d(${point.x}px, ${point.y}px, 0)`,
        };
      } else {
        return {};
      }
    },
  },

  methods: {
    ...mapActions('timemachine', [
      'MANAGED_AUDIO_INSERT_EXIT',
      'MANAGED_AUDIO_INSERT_TRIM',
      'MANAGED_AUDIO_INSERT_DELETE',
    ]),

    $_onClick_Push(e) {
      this.MANAGED_AUDIO_INSERT_EXIT();
    },

    $_onClick_Trim(e) {
      this.MANAGED_AUDIO_INSERT_TRIM().then(() => {
        tmBus.$emit('callbackChange', { e });
      });
    },

    $_onClick_Delete(e) {
      this.MANAGED_AUDIO_INSERT_DELETE().then(() => {
        tmBus.$emit('callbackChange', { e });
      });
    },
  },
};
</script>

<style lang="scss">
.tm-tracks > .tm-optional-audio-insert-menu {
  --menuHeight: 96px;

  position: absolute;
  top: 0;
  margin-top: var(--tm-pxRowBlankTop);
  z-index: var(--tm-zTrackItemMenu);
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease-in;
  background-color: #fff;
  padding: 15px 20px;
  box-shadow: 0 2px 25px rgba(0, 0, 0, 0.2);
  width: var(--tm-pxAudioDropMenuW);
  height: var(--menuHeight);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &.v {
    visibility: visible;
    opacity: 1;
  }

  > .-label {
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
  }

  > .-buttons {
    display: flex;

    > .-spring {
      width: 100%;
    }

    > .wt-button {
      height: 30px;
      font-size: 14px;
      white-space: nowrap;
      cursor: pointer;

      &.-long {
        min-width: 140px;
        margin-right: 10px;
      }
      &.-medium {
        min-width: 100px;
      }
      &.-short {
        width: 30px;
        min-width: 30px;
        .wticon {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
